import { array, mixed, object, type InferType, boolean, string, number } from 'yup'

export const logoItemSchema = object({
  image: mixed<File | ContentFile>().required(),
  altText: string().default(''),
  url: string().nullable().default(null),
  maxWidth: number().nullable().default(null),
})

export const logoBarSchema = object({
  logos: array(logoItemSchema).min(1).required(),
  grayscale: boolean().default(false),
})

export interface LogoBarPayload extends InferType<typeof logoBarSchema> {}
